<template>
  <div
    class="board-grid"
    :class="{ 'has-border': showBorder }"
    :style="{
      'grid-template-rows': `repeat(${rows}, ${cellSize}px)`,
      'grid-template-columns': `repeat(${columns}, ${cellSize}px)`,
    }"
  >
    <board-cell
      v-for="(cell, index) in table"
      :key="`${cell.positiony}-${cell.positionx}`"
      :cell="cell"
      :cell-size="cellSize"
      :settings="settings"
      :data-index="index"
      :style="{ width: cellSize + 'px', height: cellSize + 'px' }"
      :top-is-empty="isCellEmpty(cell.positionx, cell.positiony - 1)"
      :left-is-empty="isCellEmpty(cell.positionx - 1, cell.positiony)"
      :right-has-content="!isCellEmpty(cell.positionx + 1, cell.positiony)"
      :bottom-has-content="!isCellEmpty(cell.positionx, cell.positiony + 1)"
      @click="$emit('cell-click', $event)"
    />
  </div>
</template>

<script>
import BoardCell from './BoardCell.vue';

export default {
  name: 'board-grid',
  components: { BoardCell },
  props: {
    table: { type: Array, required: true },
    rows: { type: Number, required: true },
    columns: { type: Number, required: true },
    cellSize: { type: Number, default: 60 },
    settings: { type: Object, required: true },
    showBorder: { type: Boolean, default: true },
  },
  methods: {
    isCellEmpty(x, y) {
      const neighbor = this.table.find(
        cell => cell.positionx === x && cell.positiony === y,
      );
      return !neighbor || neighbor.isEmpty;
    },
  },
};
</script>

<style scoped>
.board-grid {
  display: grid;
  width: fit-content;
}

.board-grid.has-border {
  border: 2px solid #000;
}
</style>
